import { useTranslation } from "react-i18next";
import { message } from "antd";
import { ReactComponent as Copy } from "assets/icons/copy.svg";

const Accounts = ({ bankAccounts }) => {
  const { t } = useTranslation();

  const [messageApi, contextHolder] = message.useMessage();

  const handleCopyMsg = () => {
    return messageApi.open({
      type: "success",
      content: t("coppied"),
      className: "body-14px-medium",
    });
  };

  const copyTextToClipboard = async (value) => {
    if ("clipboard" in navigator) {
      handleCopyMsg();
      return await navigator.clipboard.writeText(value);
    }
  };

  return (
    <div>
      <h1 className="body-14px-medium text-gray-4 mb-3">
        {t("pma-onboarding.account-numbers")}
      </h1>
      <div className="flex flex-col gap-5">
        {contextHolder}
        {bankAccounts?.map((account) => (
          <div className="flex flex-col gap-3 px-3 py-2 border border-gray--7 rounded-lg">
            <div className=" flex justify-between items-center">
              <h2 className="body-14px-medium text-gray-4">{account?.label}</h2>
              <div className="h-10 w-10 rounded-xl bg-primary--7 flex items-center justify-center">
                {account?.icon && (
                  <img
                    src={account?.icon}
                    title={account?.label}
                    alt={account?.label}
                  />
                )}
              </div>
            </div>
            <div className=" flex justify-between items-center bg-gray--9 rounded-lg p-2">
              <h2 className="body-14px-regular text-gray-0">
                {account?.value?.account_number}
              </h2>
              <Copy
                className="cursor-pointer"
                onClick={() =>
                  copyTextToClipboard(account?.value?.account_number)
                }
              />
            </div>
            <div className=" flex justify-between items-center bg-gray--9 rounded-lg p-2">
              <h2 className="body-14px-regular text-gray-0">
                {`${account?.value?.iban}`.replace("ir", "IR ")}
              </h2>
              <Copy
                className="cursor-pointer"
                onClick={() => copyTextToClipboard(account?.value?.iban)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Accounts;
